module.exports = __webpack_public_path__ + "static/media/p2008drita.ac5df887.jpg";